var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card bg"},[_c('h2',{staticClass:"m-3 text-white"},[_c('loading-placeholder',{attrs:{"width":"120px"}})],1),_c('div',{staticClass:"m-3"},[_c('loading-placeholder',{attrs:{"width":"100%","height":"150px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }